import { TPitchId } from '../FeedSelect/IFeedSelect';

export interface IPostProps extends IPost {
  byOwner: boolean;
  isComment: boolean;
  repliedPitchName: {
    slug: string;
    name: string;
  } | false;
}

export default interface IPost {
  avatar: string;
  created_at: string;
  id: number;
  is_html_safe: boolean;
  message: string;
  name: string;
  pitch_id: TPitchId;
  profile_id: number;
  replies: IPost[];
  replies_count: number;
  subscribed: boolean;
  current_user_subscription_id: number | null;
  total_votes: number;
  current_user_vote: EPost | null;
  is_update: boolean;
  is_deleted: boolean;
}

export enum EPost {
  up = 'up',
  down = 'down',
}
